<script> 
  export default {
    name: 'Select',
    props: {
      value: {
        type: [String, Number, Object],
        default: ''
      },
      isInvalid: {
        type: Boolean,
        default: false
      }
    },
  }
</script>

<template>
  <select 
    type="text"
    class="Select" 
    :value="value"
    :class="{ 'is-invalid': isInvalid, 'text-muted': !value }"
    @input="$emit('input', $event.target.value)"
  >
    <slot></slot>
  </select>
</template>

<style lang="scss" scoped>
  .Select {
    border: var(--input-border);
    height: var(--input-height);
    padding: 0 var(--input-padding-x);
    border-radius: var(--input-radius);
    background-color: var(--input-bg);
    width: 100%;

    &:focus {
      border-color: var(--input-focus-border-color);
      box-shadow: var(--input-focus-shadow);
    }
    &:disabled {
      cursor: not-allowed;
      background-color: var(--input-disabled-bg);
    }
    &.is-invalid {
      border-color: red;
    }
  }
</style>